import { render, staticRenderFns } from "./service-fee-template.vue?vue&type=template&id=4dd1a724&"
import script from "./service-fee-template.vue?vue&type=script&lang=js&"
export * from "./service-fee-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports